import React, { Fragment, MouseEvent } from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import Input from '../Input';
import { CompanyMembersFilterBox } from '../../containers/Tasks/CompanyManagement/styles';
import messages from './Messages';
import {
  makhsanSearchUser,
  IUserInfo,
  IUserInfos,
  makhsanSearchUserFn,
} from 'store/makhsanUserInfo/makhsanUserInfoSlice';
import { debounce } from 'lodash';
import { Item, UserItems } from './styles';
import { blue, red } from '../../utils/style/colors';
import UserInfoBox from './UserInfoBox';
import ActionLink from '../ActionLink';
import SecurityLogViewPanel from './SecurityLogViewPanel';
import AccessLogViewPanel from './AccessLogViewPanel';
import { appDispatch, RootState } from 'store/store';
import { IThisUserState } from 'store/thisUser/thisUserSlice';

interface IStateToProps {
  thisUser: IThisUserState;
  userInfos: IUserInfos;
}

interface IOwnProps {}

interface DispatchToProps {
  makhsanSearchUser: (
    query: string,
    blocked?: boolean,
    from?: number,
    count?: number
  ) => ReturnType<typeof makhsanSearchUserFn>;
}
type Tab = 'info' | 'securityLogs' | 'accessLogs';
interface IComponentState {
  query: string;
  blocked?: boolean;
  loading: boolean;
  selectedUserId?: number;
  tab: Tab;
}
type IComponentProps = IStateToProps & IOwnProps & DispatchToProps;

class UserInfoManagerPanel extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  state: IComponentState = {
    loading: false,
    blocked: true,
    query: '',
    tab: 'info',
  };
  handleSetNameToSearch = (query: string) => {
    this.props.makhsanSearchUser(query, this.state.blocked);
  };

  componentDidMount(): void {
    this.props.makhsanSearchUser('', this.state.blocked);
  }

  handleChangeName = debounce(this.handleSetNameToSearch, 800);
  handleChangeInputName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    this.setState({ query });
    this.handleChangeName(query);
  };
  setBlocked = (e: React.ChangeEvent<HTMLInputElement>) => {
    let blocked: boolean | undefined = e.target.checked;
    blocked = !blocked ? undefined : blocked;
    this.setState({ blocked: blocked });
    this.props.makhsanSearchUser(this.state.query, blocked);
  };

  selectUser = (userId: number) => {
    if (this.state.selectedUserId === userId) {
      this.setState({ selectedUserId: undefined });
    } else {
      this.setState({ selectedUserId: userId });
    }
  };

  handleChangeTab = (e: MouseEvent<HTMLElement>) => {
    this.setState({ tab: e.currentTarget.dataset.tab as Tab });
  };

  render() {
    const { blocked, query, selectedUserId, tab } = this.state;
    const { userInfos } = this.props;
    const selectedUser = selectedUserId && userInfos[selectedUserId];
    const filteredUsers = Object.values(userInfos || {}).filter(
      (userInfo: IUserInfo) => {
        if (blocked && !userInfo.blocked) return false;
        if (userInfo.first_name && userInfo.first_name.includes(query))
          return true;
        if (userInfo.last_name && userInfo.last_name.includes(query))
          return true;
        if (userInfo.email && userInfo.email.includes(query)) return true;
        if (userInfo.phone && userInfo.phone.includes(query)) return true;
        return false;
      }
    );
    return (
      <div style={{ height: '100%' }}>
        <CompanyMembersFilterBox>
          <Input
            id="inputValue"
            type="text"
            label={messages.search}
            onChange={this.handleChangeInputName}
            placeholder={messages.searchHint}
            autoComplete="off"
            value={query}
            wrapperClassName="search-user-by-name-input"
          />
          <Input
            id="blocked"
            type="checkbox"
            checked={blocked || false}
            onChange={this.setBlocked}
            name="blocked"
            label={messages.blocked}
          />
        </CompanyMembersFilterBox>
        <div style={{ display: 'flex', height: '100%' }}>
          <UserItems helve={!!selectedUser}>
            {filteredUsers.map((userInfo: IUserInfo) => {
              return (
                <Item
                  className="row"
                  isActive={userInfo.user_id === selectedUserId}
                  key={userInfo.user_id.toString()}
                  onClick={() => this.selectUser(userInfo.user_id)}
                >
                  <div className="col s12 m2">
                    {messages.userId + ': ' + userInfo.user_id}
                  </div>
                  <div className="col s12 m3">
                    {messages.phone + ': ' + (userInfo.phone || '-')}
                  </div>
                  <div className="col s12 m3">
                    {messages.email + ': ' + (userInfo.email || '-')}
                  </div>
                  <div className="col s12 m3">
                    {messages.name +
                      ': ' +
                      (userInfo.first_name || '') +
                      ' ' +
                      (userInfo.last_name || '')}
                  </div>
                  <div
                    className="col s12 m2"
                    style={{ color: red, fontWeight: 'bold' }}
                  >
                    {userInfo.blocked ? messages.blocked : ''}
                  </div>
                  <div
                    className="col s12 m1"
                    style={{ color: blue, fontWeight: 'bold' }}
                  >
                    {userInfo.active2fa ? '2FA' : ''}
                  </div>
                </Item>
              );
            })}
          </UserItems>
          {selectedUser && (
            <UserItems helve={true}>
              <ul
                className="mytabs"
                style={{ marginTop: '0', marginBottom: '0' }}
              >
                <Fragment>
                  <li
                    className={`tab col s3 ${tab === 'info' ? 'active' : ''}`}
                  >
                    <ActionLink
                      color="green"
                      data-tab="info"
                      onClick={this.handleChangeTab}
                    >
                      {messages.details}
                    </ActionLink>
                  </li>
                  <li
                    className={`tab col s3 ${
                      tab === 'securityLogs' ? 'active' : ''
                    }`}
                  >
                    <ActionLink
                      color="green"
                      data-tab="securityLogs"
                      onClick={this.handleChangeTab}
                    >
                      {messages.securityLogs}
                    </ActionLink>
                  </li>
                  <li
                    className={`tab col s3 ${
                      tab === 'accessLogs' ? 'active' : ''
                    }`}
                  >
                    <ActionLink
                      color="green"
                      data-tab="accessLogs"
                      onClick={this.handleChangeTab}
                    >
                      {messages.accessLogs}
                    </ActionLink>
                  </li>
                </Fragment>
              </ul>
              {tab === 'info' && <UserInfoBox user={selectedUser} />}
              {tab === 'securityLogs' && (
                <SecurityLogViewPanel user={selectedUser} />
              )}
              {tab === 'accessLogs' && (
                <AccessLogViewPanel user={selectedUser} />
              )}
            </UserItems>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state
) => {
  const userInfos = state.makhsanUserInfo;
  const thisUser = state.thisUser;
  return { userInfos, thisUser };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  IOwnProps
> = () => {
  return {
    makhsanSearchUser: (
      query: string,
      blocked?: boolean,
      from?: number,
      count?: number
    ) => {
      return appDispatch(makhsanSearchUser({ query, blocked, from, count }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserInfoManagerPanel);
